import { addGlobalControls } from "./globalControls.js";
import { hideLevels } from "./inititalState.js";
import { addLevelListeners } from "./listeners.js";
import * as styles from "./page-manager.module.scss";

/** Instantiate the page manager. */
export default function init(): void {
	const tbody = document.getElementById("the-list") as HTMLTableSectionElement;

	if (!tbody) {
		return;
	}

	const tableElement = tbody.closest("table");
	if (!tableElement) {
		return;
	}
	tableElement.classList.add(styles.rtPages);
	addHeaderCells(tableElement);
	addGlobalControls(tableElement);
	hideLevels(tbody);
	addLevelListeners(tbody);
}

/**
 * Add cells to the table header and footer to componsate for the toggle cells
 * being added to the body.
 *
 * @param table The table with the pages.
 */
function addHeaderCells(table: HTMLTableElement) {
	const container =
		table.querySelectorAll<HTMLTableRowElement>("thead tr, tfoot tr");
	container.forEach((row) => {
		const newCell = document.createElement("th");
		newCell.style.width = "24px";
		row.prepend(newCell);
	});
}
